/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { format } from 'date-fns';
import IntlMsg from 'lorautils/intl/IntlMsg';
import PropsPanel from 'loracoms/PropsPanel';
import styles from '../GatewayStatus/styles.scss';

const kFormatter = (x) => {
  if (x) {
    return <span>{format(x, 'YYYY-MM-DD HH:mm:ss')}</span>;
  }
  return <span>--</span>;
};

const propTypes = {
  intl: intlShape.isRequired,
  status: PropTypes.string.isRequired,
  nodeStatus: PropTypes.object.isRequired,
};

class Status extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: props.status,
      nodeStatus: props.nodeStatus,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.node.status');
  }

  componentWillReceiveProps({ nodeStatus, status }) {
    if (!_.isEqual(nodeStatus, this.props.nodeStatus)) {
      this.setState({ nodeStatus });
    }
    if (status !== this.props.status) {
      this.setState({ status });
    }
  }

  render() {
    const {
      status,
      nodeStatus,
    } = this.state;
    return (
      <div className={styles.status}>
        <PropsPanel
          readOnly
          title={this.intlMsg.msg('basic.header')}
          data={nodeStatus}
          status={status}
          properties={[{
            id: 'ver',
            name: this.intlMsg.msg('ver'),
          }, {
            id: 'accuracy',
            name: this.intlMsg.msg('accuracy'),
          }, {
            id: 'roaming',
            name: this.intlMsg.msg('roaming'),
          }, {
            id: 'lastatt',
            name: this.intlMsg.msg('lastatt'),
            formatter: kFormatter,
          }, {
            id: 'lastdn',
            name: this.intlMsg.msg('lastdn'),
            formatter: kFormatter,
          }, {
            id: 'lastup',
            name: this.intlMsg.msg('lastup'),
            formatter: kFormatter,
          }, {
            id: 'nextup',
            name: this.intlMsg.msg('nextup'),
            formatter: kFormatter,
          },
          ]}
        />
        <PropsPanel
          readOnly
          title={this.intlMsg.msg('counter.header')}
          data={nodeStatus.counters || {}}
          status={status}
          properties={[{
            id: 'ackddown',
            name: this.intlMsg.msg('ackddown'),
          }, {
            id: 'initdown',
            name: this.intlMsg.msg('initdown'),
          }, {
            id: 'retrydown',
            name: this.intlMsg.msg('retrydown'),
          }, {
            id: 'tdmup',
            name: this.intlMsg.msg('tdmup'),
          }, {
            id: 'alohaup',
            name: this.intlMsg.msg('alohaup'),
          }, {
            id: 'okassemble',
            name: this.intlMsg.msg('okassemble'),
          },
          ]}
        />
      </div>
    );
  }
}

Status.propTypes = propTypes;

export default injectIntl(Status);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/NodeStatus/Status.jsx